import { render, staticRenderFns } from "./ednAlert.vue?vue&type=template&id=07d83a27"
import script from "./ednAlert.vue?vue&type=script&lang=js"
export * from "./ednAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports